// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext, useMemo} from 'react';
// @ts-ignore
import {useTranslation} from 'react-i18next';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {On_scroll_animation} from '../shared/on_scroll_animation';
import {t_element_size} from '../lib/screen_util';
import {Editor} from '../../../shared/editor/editor';
import {use_countries} from '../ui/forms/use_countries';
import zcountry from 'zcountry';
import styles from './global_content.module.less';

type i_global_content_props = {
  country: string;
  title?: string;
  subtitle?: string;
}

export const Global_content = (props: i_global_content_props)=>{
    const {theme} = useContext(Settings_context);
    const {t} = useTranslation();
    const {countries} = use_countries();
    const curr_country = useMemo(()=>{
        if (!props.country)
          return null;
        const search = props.country.toUpperCase().trim();
        return countries.find(el=>{
            const value_match = el.value?.toUpperCase() === search;
            const title_match = el.title?.toUpperCase() === search;
            const adj_name = zcountry.adj_list[el.value]?.name
                || zcountry.extra_adj_list?.[el.value]?.name;
            const adj_name_match = adj_name?.toUpperCase() === search;
            return value_match || title_match || adj_name_match;
        });
    }, [props.country, countries]);
    const v = curr_country?.value;
    const adj = v && (zcountry.adj_list[v] || zcountry.extra_adj_list[v])
        || null;
    const key = 'hp.global_content';
    const anim = [{frames: {from: 60, to: 235}, direction: 1, loop: true}];
    const anim_size: t_element_size = {
        xs: [335, 218],
        sm: [335, 218],
        all: [544, 353],
    };
    return <div className={cn(theme.container, styles.global_content)}>
      <On_scroll_animation animation={anim} cls={styles.animation}
        size={anim_size} src="animation/surfing.json" scroll_to_pos={0.5}/>
      <p className={cn(styles.caption, theme.u2)}>
        {props?.title || t<string>(`${key}.caption`)}
      </p>
      <p className={cn(styles.text, theme.H4, theme.reg,
        props?.subtitle && theme.color_n700)}>
        {props?.subtitle || t<string>(`${key}.text_with_country`,
            {adj: adj?.adj, country: adj?.name})}
      </p>
    </div>;
};

interface i_global_content_editor_props {
    value: i_global_content_props;
    on_change: (new_val: i_global_content_props)=>void;
}

export const Global_content_editor = (
{value, on_change}: i_global_content_editor_props)=>{
    return <Editor value={value} on_change={on_change} editors={[
      {key: 'title', label: 'Title', type: 'text'},
      {key: 'subtitle', label: 'Subtitle', type: 'text'},
    ]}/>;
};
